import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, endpoints } from "@/lib/api";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { Badge } from "@/components/ui/badge";
import { CalendarDays, Clock, Search } from "lucide-react";
import { Input } from "@/components/ui/input";

const fmt = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

export default function BlogPage() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");
  useEffect(() => { api.get(endpoints.posts).then(setItems).catch(() => {}); }, []);
  const cats = ["All", ...Array.from(new Set(items.map((p) => p.category)))];
  const filtered = items.filter((p) => (cat === "All" || p.category === cat) && (q === "" || (p.title + p.excerpt).toLowerCase().includes(q.toLowerCase())));
  return (
    <main>
      <PageHeader eyebrow="News & Blog" title="Field updates, program notes, transparency briefs." lead="Dated posts from our newsroom." />
      <section className="container-wide pb-16 lg:pb-24">
        <div className="flex flex-col md:flex-row md:items-center gap-4 mb-8">
          <div className="relative flex-1 max-w-md">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[hsl(var(--muted-ink))]" />
            <Input placeholder="Search articles" data-testid="blog-search" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" />
          </div>
          <div className="flex flex-wrap gap-2">
            {cats.map((c) => (
              <button key={c} data-testid={`blog-category-${c.toLowerCase()}`} onClick={() => setCat(c)} className={`h-9 px-3 rounded-full text-xs font-medium border ${cat === c ? "bg-[hsl(var(--navy))] text-background border-[hsl(var(--navy))]" : "border-[hsl(var(--border))] text-[hsl(var(--muted-ink))] hover:border-[hsl(var(--navy))]"}`}>{c}</button>
            ))}
          </div>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {filtered.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-list-card-${p.slug}`} className="group rounded-xl border border-[hsl(var(--border))] bg-card overflow-hidden card-lift">
              <div className="aspect-[16/9] overflow-hidden"><img src={p.cover_image} alt={p.title} className="h-full w-full object-cover group-hover:scale-[1.03] transition-transform" /></div>
              <div className="p-5">
                <div className="flex items-center gap-2"><Badge className="badge-navy border">{p.category}</Badge><span className="text-xs text-[hsl(var(--muted-ink))] inline-flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" /> {fmt(p.published_at)}</span></div>
                <h3 className="heading-3 mt-3 text-lg group-hover:text-[hsl(var(--orange))]">{p.title}</h3>
                <p className="text-sm text-[hsl(var(--muted-ink))] mt-2 line-clamp-3">{p.excerpt}</p>
                <div className="mt-4 text-xs text-[hsl(var(--muted-ink))] inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {p.read_min} min read</div>
              </div>
            </Link>
          ))}
          {filtered.length === 0 && <div className="col-span-full text-center text-[hsl(var(--muted-ink))] py-12">No posts match your search.</div>}
        </div>
      </section>
    </main>
  );
}
